import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }

  const position = {};

  if (to.hash) {
    position.selector = to.hash;
  }
  if (to.matched.some(m => m.meta.scrollToTop)) {
    position.x = 0;
    position.y = 0;
  }
  return position;
};

export default new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/404',
      component: () => System.import('components/common/404.vue'),
    },
    {
      path: '/chart',
      name: 'chart',
      component: () => System.import('components/common/chart.vue'),
    },
    {
      path: '/resetpassword',
      name: 'Resetpassword',
      component: () => System.import('components/login/resetpassword.vue'),
    },
    {
      path: '/updatepassword',
      name: 'Updatepassword',
      component: () => System.import('components/login/updatepassword.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/check_account_status',
      name: 'CheckAccountStatus',
      component: () => System.import('components/login/CheckAccountStatus.vue'),
    },
    {
      path: '/vuex',
      name: 'Vuex',
      component: () => System.import('components/demo/Vuex.vue'),
    },
    {
      path: '/',
      component: () => System.import('components/common/wrapper.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => System.import('components/home/Home.vue'),
        },
        {
          path: '/trend',
          name: 'Trend',
          component: () => System.import('components/trend/Trend.vue'),
          meta: { scrollToTop: true },
        },
        {
          path: '/trend/:id',
          name: 'TrendDetail',
          component: () => System.import('components/trend/TrendDetail.vue'),
          meta: { scrollToTop: true },
        },
        {
          path: '/search',
          name: 'Search',
          component: () => System.import('components/search/Search.vue'),
        },
        {
          path: '/list/:type/:page',
          name: 'List',
          component: () => System.import('components/list/List.vue'),
        },
        {
          path: '/advertisers/:advertiser_id/videos/:id',
          name: 'Detail',
          component: () => System.import('components/detail/detail.vue'),
        },
        {
          path: '/brand',
          name: 'Brand',
          component: () => System.import('components/brand/Brand.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/category/:id',
          name: 'Category',
          component: () => System.import('components/category/Category.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/userbackend',
          component: () => System.import('components/user/UserBackend.vue'),
          meta: { requiresAuth: true },
          children: [
            {
              path: '',
              name: 'userIndexBackend',
              component: () => System.import('components/user/UserIndexBackend.vue'),
            },
          ],
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js